import { useLatestPosts } from '@gik/api/posts/postsLatest';
import { ArticlesGridSkeleton } from '@gik/blog/components/ArticlesGrid/ArticlesGridSkeleton';
import { FetchProvider } from '@gik/core/components/DynamicComponent/FetchProvider';
import type WordpressPost from '@gik/core/models/wordpress/WordpressPost';
import React from 'react';
import { GivePageArticlesGrid } from './GivePageArticlesGrid';

export type TaxonomyPageLatestArticlesProps = {
  fallbackData?: WordpressPost[];
};

export function TaxonomyPageLatestArticles({ fallbackData }: TaxonomyPageLatestArticlesProps): React.ReactElement {
  const title = `Latest Articles`;

  return (
    <FetchProvider<WordpressPost[]>
      fetch={function useFetch() {
        return useLatestPosts(null, { fallbackData });
      }}
      loadingComponent={() => <ArticlesGridSkeleton title={title} />}
    >
      {({ data }) => <GivePageArticlesGrid title={title} data={data} />}
    </FetchProvider>
  );
}
